import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";

// Business Website (Default and Only App)
import { FourUVentures } from "./components/FourUVentures";

function App() {
  // Show 4uventures business site directly
  return (
    <>
      <FourUVentures />
      <Toaster position="top-right" />
    </>
  );

}

export default App;
